<!-- 
[fit]="fit"
  [size]="data.size"
  [showCloseButton]="true"
  (close)="handleClose()"
  [minWidth]="minWidth" -->
<div
  class="mfa-modal-shell"
  [class.mfa-modal-shell--center-buttons]="requireSetup">
  <scaffold-dialog
    [title]="'MFA'"
    [showCloseButton]="!requireSetup"
    (close)="handleDialogClose()">
  <div scaffoldDialogBody>
    <ng-container *ngIf="userInfo$ | async"></ng-container>

    <ng-container [ngSwitch]="view">
      <ng-container *ngSwitchCase="'initial'">
        <p [style.max-width]="'400px'" [style.text-align]="'center'">
          {{ 'mfa_has_not_yet_been_enabled_lingo' | translation }}
        </p>
        <p [style.max-width]="'400px'" [style.text-align]="'center'">
          <ng-container *ngIf="requireSetup">
            {{'you_must_setup_in_order_to_login'| translation}}

          </ng-container>
          <ng-container *ngIf="!requireSetup">{{ 'setup_additional_security_at_this_time' | translation }}</ng-container>
          
        </p>
        
      </ng-container>

      <ng-container *ngSwitchCase="'mfa'">
        <div *ngIf="mfaSetupLoadFailed" class="mfa-modal-loading" [style.padding]="'1rem'" [style.text-align]="'center'">
          <p>{{ 'mfa_setup_load_failed' | translation }}</p>
          <app-button (click)="initTotbMfaSetup()" status="primary">
            {{ 'retry' | translation }}
          </app-button>
        </div>
        <div *ngIf="isLoading && !secretCode && !mfaSetupLoadFailed" class="mfa-modal-loading">
          <app-loading-dots size="5px"></app-loading-dots>
        </div>
        <ng-container *ngIf="secretCode">
          <p [style.max-width]="'400px'" [style.text-align]="'center'">
            {{ 'please_download_an_authenticator_app_lingo' | translation }}
          </p>
          <app-qr-code [secretCode]="secretCode"></app-qr-code>
          <p [style.max-width]="'400px'" [style.text-align]="'center'">
            {{
              'please_enter_the_code_that_is_displayed_within_your_authenticator_app'
                | translation
            }}
          </p>
          <form (keydown.enter)="submitTotbUsercode($event)">
            <div class="mfa-modal-user-input-container">
              <app-input
                [control]="totbCodeControl"
                [label]="'code' | translation"
                [placeholder]="'code' | translation | uppercase"
                [disabled]="isSubmitting">
              </app-input>
            </div>
          </form>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
  <div scaffoldDialogButtons>
    <ng-container [ngSwitch]="view">
      <ng-container *ngSwitchCase="'initial'">
        <app-button
          *ngIf="!requireSetup"
          (click)="close()"
          status="secondary">
          {{ 'later' | translation }}
        </app-button>
        <app-button (click)="showMfaSetup()" status="primary">
          {{ 'setup' | translation }}
        </app-button></ng-container
      >
      <ng-container *ngSwitchCase="'mfa'">
        <app-button
          *ngIf="!requireSetup"
          [disabled]="isSubmitting"
          (click)="close()"
          status="secondary">
          {{ 'cancel' | translation }}
        </app-button>
        <app-button
          [isProcessing]="isSubmitting"
          [disabled]="isSubmitting || !totbCodeControl.value"
          (click)="submitTotbUsercode($event)"
          status="primary">
          {{ 'submit' | translation }}
        </app-button></ng-container
      >
    </ng-container>
  </div>
  </scaffold-dialog>
</div>
